import * as Const from "./const"

const styles = {
    [Const.TITLE]: {
        fontSize: 26,
        alignment: "center",
        lineHeight: 1.25,
    },
    [Const.SUB_TITLE]: {
        fontSize: 22,
        alignment: "center",
        lineHeight: 1.25,
    },
    [Const.TITLE_DESCRIPTION]: {
        fontSize: 11,
        lineHeight: 1.75,
    },
    [Const.COPYRIGHT]: {
        fontSize: 10,
        lineHeight: 1.25,
        alignment: "justify",
    },
    [Const.HEADER]: {
        fontSize: 32,
        margin: [0, 0, 0, 60],
    },
    [Const.SUB_HEADER]: {
        fontSize: 14,
        margin: [0, 10, 0, 15],
    },
    [Const.PARAGRAPH]: {
        lineHeight: 1.25,
    },
    [Const.TOC_HEADER]: {
        bold: true,
        fontSize: 12,
    },
    [Const.TOC_ITEM]: {
        fontSize: 10,
    },
    [Const.LIST]: {
        margin: [30, 5, 0, 15],
        lineHeight: 1.25,
    },
    [Const.TABLE]: {
        fontSize: 11,
        margin: [0, 5, 0, 0],
    },
}
export default styles
